import { render, staticRenderFns } from "./BankHolidaysToggleEdit.vue?vue&type=template&id=64009696&scoped=true"
import script from "./BankHolidaysToggleEdit.vue?vue&type=script&lang=js"
export * from "./BankHolidaysToggleEdit.vue?vue&type=script&lang=js"
import style0 from "./BankHolidaysToggleEdit.vue?vue&type=style&index=0&id=64009696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64009696",
  null
  
)

export default component.exports